export const currency = (value) => {
  let formatted;
  if (value === 0) {
    return 'R$ 0';
  }
  if (value) {
    formatted = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  }
  return formatted;
};
